<template>
  <v-layout row justify-center>
    <v-dialog v-model="imageZoomDialogOpen" transition="dialog-bottom-transition">
      <v-card>
          <v-btn id="closeImageZoomBtn" fab small dark class="close-button" @click="closeDialog()">
            <v-icon class="close material-icons">clear</v-icon>
          </v-btn>
        <img :src="image" class="dialog_image">
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  data () {
    return {
      imageZoomDialogOpen: false
    }
  },
  props: {
    image: {
      type: String,
      default: null
    }
  },
  methods: {
    closeDialog () {
      this.imageZoomDialogOpen = false
      this.$emit('zoomImageDialogClosed')
    }
  },
  watch: {
    image (img) {
      this.imageZoomDialogOpen = !!img
    }
  }
}
</script>
<style lang="stylus" scoped>
  @import '~@/styles/variables'
  .v-dialog
    align-items: center
    transition: 0s
    width: auto

  .v-dialog__content
    z-index: 11000 !important

  #closeImageZoomBtn
    position: fixed
    background-color: $color_2
    border: none

  .dialog_image
    width: 100%
    height: inherit !important

  @media screen and (min-width: 301px) and (max-width: 350px)
    .isMobile .v-dialog
      display: none

  @media screen and (min-width: 351px) and (max-width: 400px)
    .isMobile .v-dialog
      display: none

  @media screen and (min-width: 401px) and (max-width: 500px)
    .isMobile .v-dialog
      display: none

  @media screen and (max-width: 768px)
    .isMobile .v-dialog
      display: none

</style>
